import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { ImportTasksControls } from 'components/underwrite/postAcquisition/import/importTasks';
import { LoadingOverlayWrapper } from 'components/layout';
import { ImportTaskHistoryGrid } from 'components/underwrite/postAcquisition/import/importTaskHistory';
import { ImportNav } from 'components/underwrite/shared/import';
import { Switch, Route, Redirect, withRouter } from 'react-router-dom';
import { RouteWithTitle } from 'routes';
import { Constants } from 'utilities/constants';
import StoreMallDirectoryIcon from '@material-ui/icons/StoreMallDirectory';
import HistoryIcon from '@material-ui/icons/History';
import { importModuleStateSelector } from 'store/selectors';

const Import = ({ classes, importLoadingOverlayState }) => {
  const [
    taskHistoryLoadingState,
    setTaskHistoryLoadingState
  ] = React.useState({ isLoading: false, message: null });

  const renderImportTask = () =>
    <LoadingOverlayWrapper
      className={classes.overlay}
      active={importLoadingOverlayState?.isLoading}
      message={importLoadingOverlayState.message}
    >
      <ImportTasksControls/>
    </LoadingOverlayWrapper>;

  const renderImportTaskHistory = () => <>
    <LoadingOverlayWrapper
      className={classes.overlay}
      active={taskHistoryLoadingState.isLoading}
      message={taskHistoryLoadingState.message}
    >
      <ImportTaskHistoryGrid
        loading={taskHistoryLoadingState}
        setLoading={setTaskHistoryLoadingState}
      />
    </LoadingOverlayWrapper>
  </>;

  return (
    <div className={classes.root}>
      <ImportNav
        moduleName={Constants.Module.POSTACQ}
        pages={[
          { title: 'Task Import', route: Constants.Routes.POSTACQ_IMPORT_TASK, icon: <StoreMallDirectoryIcon /> },
          { title: 'Task Import History', route: Constants.Routes.POSTACQ_IMPORT_TASK_HISTORY, icon: <HistoryIcon /> }
        ]}
      />
      <div className={classes.content}>
        <Switch>
          <RouteWithTitle exact path={Constants.Routes.POSTACQ_IMPORT_TASK} title={Constants.RouteTitles.POSTACQ_IMPORT_TASK} render={renderImportTask} />
          <RouteWithTitle exact path={Constants.Routes.POSTACQ_IMPORT_TASK_HISTORY} title={Constants.RouteTitles.POSTACQ_IMPORT_TASK_HISTORY} render={renderImportTaskHistory} />
          <Route
            render={() => {
              return <Redirect to={Constants.Routes.POSTACQ_IMPORT_TASK} />; //  /Task is the default route
            }}
          />
        </Switch>
      </div>
    </div>
  );
};

const styles = theme => ({
  root: {
    display: 'flex',
    width: '100%'
  },
  content: {
    height: 'calc(100vh - (100vh - 100%) - 48px)',
    width: 'calc(100vw - (100vw - 100%) - 48px)',
    padding: theme.spacing(2),
    paddingTop: theme.spacing(),
    display: 'flex',
    flexDirection: 'column',
    overflow: 'auto'
  },
  overlay: {
    height: '100%',
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'column'
  },
  colorPrimary: {
    backgroundColor: 'rgb(189, 189, 189)'
  },
  barColorPrimary: {
    backgroundColor: 'black'
  }
});

const mapStateToProps = state => {
  const importState = importModuleStateSelector(state, Constants.Module.POSTACQ);
  return {
    importLoadingOverlayState: importState.importLoadingOverlayState,
  }
}

export default compose(
  withRouter,
  withStyles(styles),
  connect(mapStateToProps, null)
)(Import);
